import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import BarChart from "../components/d3controller"
import Instructions from "../components/keywordsInstructions"

const GraphPage = ({data}) => (
  <>
    <Layout>
      <div style={{width:`95%`, margin:`auto`}}>
        <SEO title="Corpus Analysis" />
        <header style={{marginTop:`2rem`}}>
          <h1>{data.allMarkdownRemark.edges[0].node.frontmatter.page_title}</h1>
        </header>
        <Instructions />
        <BarChart />
        {` `}
      </div>
    </Layout>
  </>
)

export default GraphPage

export const query = graphql`
query keywords_title {
  allMarkdownRemark(filter: {frontmatter: {keywords_filter: {eq: true}}}) {
    edges {
      node {
        frontmatter {
          page_title
        }
      }
    }
  }
}
`
